// P1B-FE — stream-session observability (recent sessions + "why did it fail").
import { useQuery } from "@tanstack/react-query";

import { api } from "./client";

export interface StreamSessionRow {
  id: string;
  camera_logical_id: string;
  status: string;
  status_label: string;
  purpose: string;
  selection_reason: string | null;
  selection_label: string | null;
  failure_reason_code: string | null;
  failure_label: string | null;
  requested_at: string | null;
  admitted_at: string | null;
  active_at: string | null;
  ended_at: string | null;
}

export interface StreamSessionExplain {
  session_id: string;
  camera_logical_id: string;
  status: string;
  status_label: string;
  purpose: string;
  selection_reason: string | null;
  selection_label: string | null;
  failure_reason_code: string | null;
  failure_label: string | null;
  failure_detail: string | null;
  what_happened: string;
  requested_at: string | null;
  ended_at: string | null;
}

export function useStreamSessions(cameraId: string | undefined, limit = 20) {
  return useQuery({
    queryKey: ["stream-sessions", cameraId, limit] as const,
    queryFn: async () => {
      const { data } = await api.get<StreamSessionRow[]>(
        `/api/v1/streaming/sessions?camera_id=${cameraId}&limit=${limit}`,
      );
      return data;
    },
    enabled: Boolean(cameraId),
    // Sessions are diagnostic, not real-time — refetch on focus, no polling.
    refetchOnWindowFocus: true,
  });
}

export function useSessionExplain(sessionId: string | undefined) {
  return useQuery({
    queryKey: ["stream-session-explain", sessionId] as const,
    queryFn: async () => {
      const { data } = await api.get<StreamSessionExplain>(
        `/api/v1/streaming/sessions/${sessionId}/explain`,
      );
      return data;
    },
    enabled: Boolean(sessionId),
  });
}
